// 函数节流
let lastTime = 0;
const Throttle = (func, time) => {
    // 函数节流 指定时间内只能执行一次代码 还有函数防抖
    if (!time) {
        time = 800
    }
    let nowTime = new Date().getTime()
    if (nowTime - lastTime > time || !lastTime) {
        func()
        lastTime = nowTime
    }
}

export default Throttle


// WEBPACK FOOTER //
// ./src/mixins/methods/throttle.js